const columns = [
  {
    key: "deviceCode",
    zh: "整机编号",
    en: "Device Code",
    width: "14%"
  },
  {
    key: "company",
    zh: "公司名称",
    en: "Company",
    width: "25%"
  },
  {
    key: "model",
    zh: "机型",
    en: 'Model',
    width: "15%"
  },
  {
    key: "runTime",
    zh: "运行时间(h)",
    en: "Run Time(h)",
    width: "15%"
  },
  {
    key: "maintainTime",
    zh: "保养时间(h)",
    en: "Maintain Time(h)",
    width: "18%"
  },
  {
    key: "leaveDays",
    zh: "剩余天数",
    en: "Leave Days",
    width: "13%"
  }
]

export default columns